import { apiClient } from '../client';

export interface CatalogedPermission {
  id: number; code: string; module: string; resource: string | null; action: string; label: string;
  description: string; category: string; permission_type: string; sensitivity: string;
  requires_scope: number; is_system: number; is_active: number; display_order: number;
}

export const permissionCatalogueApi = {
  list: () => apiClient.get<{ data: CatalogedPermission[] }>('/api/admin/permissions'),
};
